<template>
    <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
        <input ref="input" type="text" :id="id" aria-label="Date-Time" readonly>
        <div :id="tuiDatepickerContainerId" class="tui-datepicker_calendar" :style="wrapperStyle"></div>
    </div>
</template>

<script>
import TUIDatePicker from "tui-date-picker";

TUIDatePicker.localeTexts['id'] = {
        titles: {
            DD: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
            D: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
            MMM: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
            MMMM: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
        },
        titleFormat: 'MMMM yyyy',
        todayFormat: 'Hari ini: DD d MMMM yyyy',
        date: 'tanggal',
        time: 'waktu',
    };

    TUIDatePicker.localeTexts['zh_TW'] = {
        titles: {
            DD: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            D: ['日', '一', '二', '三', '四', '五', '六'],
            MMM: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            MMMM: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        },
        titleFormat: 'yyyy年 M月',
        todayFormat: '今天: yyyy/MM/dd (D)',
        date: '日期',
        time: '時間',
    };

    const INPUT_FORMAT = {
        kr: 'yyyy.MM.dd',
        id: 'dd/MM/yyyy',
        'zh_TW': 'yyyy/MM/dd',
    }

    export default {
        inheritAttrs: false,
        name: "TUIDatepickerInput",

        props: {
            id: {
                type: String,
                required: true
            },
            selectableRangeStart: {
                type: Date,
                default() {
                    return new Date(1970, 1, 1);
                }
            },
            selectableRangeEnd: {
                type: Date,
                default() {
                    return new Date(2099, 12, 31);
                }
            },
            value: {
                type: Date
            },
            position: {
                type: String,
                default: 'bottom'
            },
            lang: {
                default: 'ko'
            }
        },

        data() {
            return {
                tuiDatepickerContainerId: `${this.id}-container`,
                datepicker: null
            }
        },

        watch: {
            value(newValue) {
                this.$nextTick(function () {
                    if (!this.datepicker) {
                        return;
                    }

                    this.datepicker.setDate(newValue);
                });
            }
        },

        computed: {
            wrapperStyle() {
                if (this.position === 'top') {
                    return {
                        position: 'absolute',
                        top: '-407px'
                    }
                } else {
                    return {};
                }
            },
        },

        methods: {
            focus() {
                this.$refs.input.focus();
            }
        },

        mounted() {
            this.$nextTick(function () {
                this.datepicker = new TUIDatePicker(`#${this.tuiDatepickerContainerId}`, {
                    date: this.value,
                    language: this.lang,
                    selectableRanges: [
                        [this.selectableRangeStart, this.selectableRangeEnd]
                    ],
                    input: {
                        element: `#${this.id}`,
                        format: INPUT_FORMAT[this.lang]
                    }
                });

                this.datepicker.on('change', () => {
                    this.$emit('input', this.datepicker.getDate());
                });
            });
        },

        beforeDestroy() {
            this.datepicker.destroy();
        }
    }
</script>

<style scoped>

</style>
